<template>
  <div class="content">
    <div class="flex-box">
      <div class="f-item">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>通知公告</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              @click="handlePathClick('/notice')">查看更多</el-button>
          </div>
          <template v-if="notices && notices.length > 0">
            <ul class="ul-style">
              <li class="item" v-for="item in notices" :key="item.id">
                <p class="p-l">{{ item.title }}</p>
                <p class="p-r">{{ item.created_at ? item.created_at.substring(0, 10) : '' }}</p>
              </li>
            </ul>
          </template>
          <el-empty v-else description="暂无通知" style="width: 100%;"></el-empty>
        </el-card>
      </div>
      <div class="f-item" v-for="item in tabs">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ item.label }}</span>
          </div>
          <div class="flex">
            <template v-for="menu in menus">
              <div class="item" v-if="menu.module == item.module" :key="menu.index" @click="handleRouterTo(menu.path)">
                <el-badge v-if="menu.index == '2-4' && $store.state.doge > 0" :value="$store.state.doge" :max="99">
                  <div class="item-icon"><i :class="`${menu.icon} i-style`"></i></div>
                  <p class="item-title">{{ menu.title }}</p>
                </el-badge>
                <template v-else>
                  <div class="item-icon"><i :class="`${menu.icon} i-style`"></i></div>
                  <p class="item-title">{{ menu.title }}</p>
                </template>
              </div>
            </template>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import CustomTable from "@/components/CustomTable";
import CustomTableColumn from "@/components/CustomTableColumn";
export default {
  name: 'demoEchart',
  mixins: [mixinFormatter],
  data() {
    return {
      notice: {
        page: 0,
        size: 4,
        total: 0,
        tableData: [],
      },
      notices: [],
      file: {
        page: 0,
        size: 10,
        total: 0,
        tableData: [],
      },
      cheight: '330px',
      message: {
        query: false,
        tableData: [],
      },
      swipes: [],
      counts: {},
      offsetHeight: '500px',
      scrollHeight: '400px',
      userInfo: {
        name: '',
        number: '',
        defaultStructure: {
          name: '',
        },
        login_time: '',
      },
      tabs: []
    };
  },
  components: {
    // 'v-chart': ECharts,
    CustomTableColumn,
    CustomTable,
  },
  created() {
    // this.getBanners();
    this.userInfo = this.$store.state.userInfo;
    this.getNoticeList();
    this.getTabs();
  },
  mounted() {
    this.offsetHeight = document.body.offsetHeight + 'px';
  },
  computed: {
    menus: function () {
      let menus = [];
      this.$store.state.menu.map((item) => {
        if (item.childs && item.childs.length) {
          item.childs.map((menu) => {
            if (!this.$store.state.h5HideMenu.includes(menu.path)) {
              menu.module = item.module;
              menus.push(menu);
            }
          });
        }
      });
      return menus;
    },
    userType: function () {
      let usertype = '';
      if (this.$store.state.posts && this.$store.state.posts.length > 0) {
        this.$store.state.posts.map((item) => {
          if (item.value == this.userInfo.usertype) {
            usertype = item.label;
          }
        });
      }
      return usertype;
    },
  },
  methods: {

    getTabs() {
      this.tabs = [];
      let menuStr = JSON.stringify(this.$store.state.menu);
      // console.log(menuStr)
      this.$store.state.defaultModules.map((item) => {
        // console.log(menuStr.indexOf(item.module))
        if (menuStr.indexOf(item.module) > -1) {
          this.tabs.push(item);
        }
      });
      if (this.tabs.length) {
        this.$store.commit('setModules', this.tabs);
        // this.$store.commit('setCurrentModule', this.tabs[0].module);
      }
    },

    handleRouterTo(path) {
      this.$router.push({
        path: path
      });
    },
    handlePathClick(path) {
      this.$router.push({
        path,
      });
    },
    hadleFileClick(url) {
      const link = document.createElement('a');
      let fname = this.downloadName;
      link.href = url;
      link.setAttribute('download', fname);
      document.body.appendChild(link);
      link.click();
    },
    async getNoticeList() {
      let params = {
        page: 1,
        size: 4,
      };
      let res = await this.$api.query.getNoticesUnload(params);
      if (res.code == 0 && res.data) {
        this.notices = res.data.data;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0 12px;
  // background-color: #EFEFEF;
  height: 100%;
  margin-top: 4px;
}

.entry {
  background: var(--bule);

  // background-position: center center;
  width: 100%;
  height: 100%;
  background-size: cover;
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  // padding-bottom: 50%;
}

.carousel {
  box-shadow: 0 2px 12px 0 #11111147;
  width: calc(100% - 6px);
  margin: 0 auto;
}

// /deep/ .el-carousel__item {
//   display: block;
//   position: relative;
// }


/deep/.el-badge__content.is-fixed {
  top: 2px;
  right: 30px;
}

/deep/ .el-badge__content.is-fixed.is-dot {
  right: -4px;
  top: 16px;
}

/deep/.el-card {
  height: auto !important;
  border-radius: 4px;
}

/deep/.el-card__header {
  border: 0;
  font-size: 15px;
  color: #777;
  font-weight: bold;
  letter-spacing: 1.3px;
  padding: 10px 12px 8px;
}

/deep/.el-empty {
  padding: 0;
}

.flex-box {
  .f-item {
    padding: 0 0 4px;
    box-sizing: border-box;

    /deep/.el-card {
      height: 100%;
    }

    .ul-style {
      list-style: none;
      padding: 0 8px 12px;
      box-sizing: border-box;

      li {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        padding: 4px;
        border-bottom: 1px solid var(--lightGray);
        margin: 0;

        .p-top {
          width: 100%;
          text-align: center;
          background-color: var(--grayBlue);
          color: var(--white);
          font-size: 15px;
          font-weight: bold;
          padding: 4px 32px;
          margin: 0 auto 6px;
          border-radius: 15px;
        }

        .p-title {
          width: 120px;
          font-weight: bold;
          text-align: left;
          text-indent: 8px;
        }

        .p-content {
          flex: 1;
        }

        .p-l {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex: 1;
        }


        .p-r {
          color: var(--gray);
          text-align: right;
          font-size: 12px;
          width: 120px;
        }
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  font-size: 15px;
  padding: 8px 10px 8px;
  flex-wrap: wrap;

  .item {
    // padding: 4px;
    // margin-right: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 0 4px;
    box-sizing: border-box;
    width: 25%;
    text-align: center;
    .item-icon {
      text-align: center;
    }

    .i-style {
      color: var(--blue);
      font-size: 26px;
    }

    .item-title {
      margin-top: 4px;
      font-size: 13px;
      color: #5a5a5a;
      text-align: center;
    }
  }
}

.pageHeader {
  margin-bottom: 12px;
}

.pageHeader:before {
  width: 64px;
}


@media screen and (min-width: 1000px) {}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {
  .icon-div img {
    width: 24px !important;
  }

  .top-item .num {
    font-size: 16px !important;
  }

  .top-item .label {
    padding: 0 8px;
    font-size: 18px !important;
  }

  /deep/.el-card__body {
    padding: 0 4px !important;
  }

  .f-item {
    width: 100% !important;
  }

}
</style>
